import React, { useContext } from 'react';
import styled from 'styled-components';

export const RFQBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.textGrey}; 
  color:${(props) => props.theme.cardBackground}; 
  font-size: 0.8vw;
  font-weight: bold;
  padding: 0.15vw 0.4vw;
  border-radius: 5vw;;
  white-space: nowrap;
  // margin-left: 0.5vw;
`;

